const analyticsOffersModule = {
  state: {
    items: null,
    best_selling: null,
    most_abandoned: null,
    most_viewed: null,
    most_viewed_not_selling: null,
    loading: {
      best_selling: false,
      most_abandoned: false,
      most_viewed: false,
      most_viewed_not_selling: false
    }
  },
  mutations: {
    setAnalyticsOffers (state, data) {
      state.items = data
    },
    setAnalyticsOffersByType (state, { type, data }) {
      state[type] = data
    },
    setAnalyticsOffersLoading (state, { type, loading }) {
      state.loading[type] = loading
    }
  },
  getters: {
    getAnalyticsOffers: (state) => {
      return state.items
    },
    getAnalyticsOffersByType: (state) => (type) => {
      return state[type]
    },
    getAnalyticsOffersLoading: (state) => (type) => {
      return state.loading[type]
    }
  }
}

export default analyticsOffersModule



// WEBPACK FOOTER //
// ./src/store/modules/analytics_offers.js